
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { getTodayForDisplay } from "@/utils/dateUtils";
import { WordPreviewScreen } from "../screens/WordPreviewScreen";
import type { Word, LogicRule } from "@/lib/game-utils";

interface TodaysResultModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedWords: Array<{ word: Word; order: number }>;
  selectedRule: LogicRule;
}

export function TodaysResultModal({ 
  open, 
  onOpenChange,
  selectedWords,
  selectedRule
}: TodaysResultModalProps) {
  const displayDate = getTodayForDisplay();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden rounded-xl">
        <div className="relative">
          <div className="pt-3 pb-1">
            <div className="text-xs text-center text-gray-400 mt-1">
              {displayDate}
            </div>
          </div>
          
          <button
            onClick={() => onOpenChange(false)}
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>
          
          <div className="max-h-[80vh] overflow-y-auto pb-5">
            <div className="px-4 py-0">
              <WordPreviewScreen 
                selectedWords={selectedWords}
                selectedRule={selectedRule}
                onRevealResults={() => {}} // No-op since we're in preview mode
                previewMode={true}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
